import { useEffect } from 'react';

const useAriaHiddenFix = ref => {
  useEffect(() => {
    const setTabIndex = (node, value) => {
      const focusableElements =
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
      node
        .querySelectorAll(focusableElements)
        .forEach(el => el.setAttribute('tabIndex', value));
    };

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          const hiddenItems = ref.current.querySelectorAll(
            "[aria-hidden='true']",
          );
          hiddenItems.forEach(item => setTabIndex(item, -1));
        }
      });
    });

    if (ref.current) {
      observer.observe(ref.current, { childList: true, subtree: true });
    }

    return () => observer.disconnect();
  }, [ref]);
};

export default useAriaHiddenFix;
